import * as React from 'react';
import 'isomorphic-fetch';
import { PersonSummary } from './PersonSummary';
import { ChangePassword } from './ChangePassword';
export class MyPage extends React.Component {
    constructor() {
        super();
        this.state = { selectedPage: 0 };
    }
    render() {
        let selectedPage = React.createElement("div", null);
        if (this.state.selectedPage == 0) {
            selectedPage = React.createElement("div", null,
                React.createElement(PersonSummary, null));
        }
        else if (this.state.selectedPage == 1) {
            selectedPage = React.createElement("div", null,
                React.createElement(ChangePassword, null));
        }
        return React.createElement("div", null,
            React.createElement("ul", { className: "nav nav-tabs" },
                React.createElement("li", { className: this.getPageStyle(0) },
                    React.createElement("a", { onClick: () => { this.selectPage(0); } }, "Summary")),
                React.createElement("li", { className: this.getPageStyle(1) },
                    React.createElement("a", { onClick: () => { this.selectPage(1); } }, "Change Password"))),
            React.createElement("br", null),
            React.createElement("div", { className: "well" }, selectedPage));
    }
    selectPage(newPageNumber) {
        this.setState({ selectedPage: newPageNumber });
    }
    getPageStyle(pageNumber) {
        if (pageNumber == this.state.selectedPage) {
            return "active";
        }
        return "";
    }
}
//# sourceMappingURL=MyPage.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/MyPage/MyPage.js
// module id = 91
// module chunks = 0